import React from 'react';
import styled, {css} from 'styled-components';
import * as routeNames from '../constants/AccountRoutes';
import { Button } from 'synapsefi-dev-ui';
import Colors from '../../../../constants/colors';

const NavigationContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const NavigationHeader = styled.div`
    border-bottom: 1px solid ${Colors.SEPARATOR_GRAY};
    padding-bottom: 15px;
`;

const TabList = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    margin-bottom: 16px;
`;

const TabItem = styled.span`
    color: ${Colors.PLACEHOLDER_GRAY};
    cursor: pointer;
    font-family: Nunito Sans;
    font-size: 14px;
    user-select: none;
    display: flex;
    align-items: center;
    border-radius: 50vh;
    padding: 5px 16px;
    letter-spacing: .2px;
    width: max-content;
    margin-bottom: 10px;
    max-height: 23px;
    transition: .3s ease color;

    &:hover {
        color: ${Colors.DARK_NIGHT};
    }

    ${props => props.isActive ? `
        color: ${Colors.WHITE};
        background: black;

        &:hover {
            color: ${Colors.WHITE};
        }
        `: `
        color: ${Colors.PLACEHOLDER_GRAY};
        background: transparent;
        `
    }

    ${props => props.isFirst && css`margin-bottom: 0px;`}
`;

const routeData = {
    'Amazon': {
        route: `${routeNames.ROUTE_ACCOUNTS_AMAZON}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'ATM': {
        route: `${routeNames.ROUTE_ACCOUNTS_ATM}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'Gas Station': {
        route: `${routeNames.ROUTE_ACCOUNTS_GAS_STATION}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'Green Dot': {
        route: `${routeNames.ROUTE_ACCOUNTS_GREEN_DOT}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'Paypal': {
        route: `${routeNames.ROUTE_ACCOUNTS_PAYPAL}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'Uber': {
        route: `${routeNames.ROUTE_ACCOUNTS_UBER}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'Venmo': {
        route: `${routeNames.ROUTE_ACCOUNTS_VENMO}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'Whole Foods': {
        route: `${routeNames.ROUTE_ACCOUNTS_WHOLE_FOODS}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
    'In N Out': {
        route: `${routeNames.ROUTE_ACCOUNTS_RESTAURANT}`,
        baseRoute: `${routeNames.ROUTE_ACCOUNTS}`,
    },
};


function AccountNavigation({ history, location, handlePopulate, handleReset }) {
    const currentRoute = location.pathname;

    const renderTabs = () => {
        const tabs = Object.keys(routeData).map((title) => {
            if (title === 'Custom') return;

            const { route } = routeData[title];
            const isActive = currentRoute.includes(route);

            return (
                <TabItem
                    key={title}
                    title={title}
                    isActive={isActive}
                    onClick={() => history.push(route)}
                >
                    {title}
                </TabItem>
            );
        });

        return tabs;
    }

    return (
        <NavigationContainer>
            <NavigationHeader
                isFirst={true}
            >
                <TabItem
                    isFirst={true}
                    key={'Custom'}
                    title={'Custom'}
                    isActive={currentRoute.includes(routeNames.ROUTE_ACCOUNTS_CUSTOM)}
                    onClick={() => history.push(routeNames.ROUTE_ACCOUNTS_CUSTOM)}
                >
                    Custom
                </TabItem>
            </NavigationHeader>
            <TabList>
                {renderTabs()}
            </TabList>
        </NavigationContainer>
    );
}

export default AccountNavigation;